import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success("If that email exists, a reset link has been sent.");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-cream px-5 py-12">
      <div className="w-full max-w-md card-surface p-8">
        <h1 className="font-display text-3xl font-semibold text-center text-brand-ink">Reset Password</h1>
        {sent ? (
          <p className="mt-4 text-center text-brand-inksoft text-sm">Check your email for a reset link. (In this demo the link is logged to the backend console.)</p>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <input data-testid="forgot-email" type="email" required placeholder="Your email" className="input-field" value={email} onChange={(e) => setEmail(e.target.value)} />
            <button data-testid="forgot-submit" className="btn-primary w-full">Send Reset Link</button>
          </form>
        )}
        <p className="mt-4 text-center text-sm"><Link to="/login" className="text-brand-sage hover:underline">Back to login</Link></p>
      </div>
    </div>
  );
}
